import { render, staticRenderFns } from "./Botones.vue?vue&type=template&id=05ab0a5c&scoped=true&"
import script from "./Botones.vue?vue&type=script&lang=js&"
export * from "./Botones.vue?vue&type=script&lang=js&"
import style0 from "./Botones.vue?vue&type=style&index=0&id=05ab0a5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ab0a5c",
  null
  
)

export default component.exports